namespace $ {
	
	export let $mol_spell_any = $mol_spell_ru
	
}
